import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from "@angular/forms";
import { CheckboxModule } from "primeng/components/checkbox/checkbox";
import { CheckboxComponent } from './checkbox.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    CheckboxModule
  ],
  declarations: [CheckboxComponent],
  exports: [CheckboxComponent]
})
export class ndCheckboxModule { }
